import { MenuHelper, IMenuDefinition, menuType } from "@/helpers/MenuHelper";

export function init() {
  MenuHelper.addMenuDefinition(
    { name: "Change_Password", description: "Cambia password", icon: "fas fa-user", routeName: "Change_Password", orderIndex: 1 } as IMenuDefinition,
  );

  MenuHelper.addMenuDefinition(
    { name: "Change_Data", description: "Modifica profilo", icon: "fas fa-user", routeName: "Change_Data", orderIndex: 1 } as IMenuDefinition,
  );
}